// extracted by mini-css-extract-plugin
export default {"container":"style_container__f9ewm","noWidth":"style_noWidth__xa7Tm"};